// Funzione di utilità per formattare la valuta (es. USD)
const formatCurrency = (value, currency = 'USD') => {
    let formattedValue;
    if (Math.abs(value) >= 1e9) {
        formattedValue = new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((value / 1e9).toFixed(2)) + 'B';
    } else if (Math.abs(value) >= 1e6) {
        formattedValue = new Intl.NumberFormat('en-US', { style: 'currency', currency }).format((value / 1e6).toFixed(2)) + 'M';
    } else {
        formattedValue = new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value.toFixed(2));
    }
    return formattedValue;
};

// Convert ISO 4217 currency codes to symbols
const currencySymbols = {
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CNY': '¥',
    'INR': '₹',
    // Aggiungi altre valute se necessario
};

export const getCurrencySymbol = (currency) => {
    return currencySymbols[currency] || currency;
};

export default formatCurrency;